export default __webpack_public_path__ + "static/coffee3-a46b9c44320efdb52b23f43151bf06d8.png";